import { createContext, useContext, useState, ReactNode, useMemo } from 'react'

interface LeadAnnotations {
  [key: string]: string // key é o nome do lead
}

interface ECGAnnotationsContextType {
  annotations: LeadAnnotations
  addAnnotation: (lead: string, annotation: string) => void
  clearAnnotations: () => void
  getAnnotation: (lead: string) => string
}

const ECGAnnotationsContext = createContext<
  ECGAnnotationsContextType | undefined
>(undefined)

interface ECGAnnotationsProviderProps {
  children: ReactNode
}

export const ECGAnnotationsProvider = ({
  children
}: ECGAnnotationsProviderProps) => {
  const [annotations, setAnnotations] = useState<LeadAnnotations>({})

  const addAnnotation = (lead: string, annotation: string) => {
    setAnnotations(prev => ({
      ...prev,
      [lead]: annotation
    }))
  }

  const clearAnnotations = () => {
    setAnnotations({})
  }

  const getAnnotation = (lead: string): string => {
    return annotations[lead] || ''
  }

  const value = useMemo(
    () => ({ annotations, addAnnotation, clearAnnotations, getAnnotation }),
    [annotations]
  )

  return (
    <ECGAnnotationsContext.Provider value={value}>
      {children}
    </ECGAnnotationsContext.Provider>
  )
}

export const useECGAnnotations = () => {
  const context = useContext(ECGAnnotationsContext)
  if (!context) {
    throw new Error(
      'useECGAnnotations must be used within ECGAnnotationsProvider'
    )
  }
  return context
}
